import { render, staticRenderFns } from "./CoinNetworkWelcomeModal.vue?vue&type=template&id=2ce99afc&scoped=true&"
import script from "./CoinNetworkWelcomeModal.vue?vue&type=script&lang=ts&"
export * from "./CoinNetworkWelcomeModal.vue?vue&type=script&lang=ts&"
import style0 from "./CoinNetworkWelcomeModal.vue?vue&type=style&index=0&id=2ce99afc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce99afc",
  null
  
)

export default component.exports